import createIcon from '../../createIcon';

/**
 * @component @name EggAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMDAwNCA5QzE3LjAwMDQgNyAxNS45OTA0IDIgOS45NzAzOSAyQzQuOTUwMzkgMiAxLjk0MDM5IDYgMi4wMDAzOSAxMS41MkMyLjA2MDM5IDE3LjA0IDYuOTYwMzkgMTkgOS45NzAzOSAxOUMxMS45ODA0IDE5IDExLjk4MDQgMjIgMTUuOTkwNCAyMkMxOS4wMDA0IDIyIDIyLjAwMDQgMTkgMjIuMDAwNCAxNS4wMkMyMi4wMDA0IDEyIDIxLjAxMDQgMTEgMTkuMDAwNCA5Wk0xMi4wMDA0IDE1LjVDMTAuMDcwNCAxNS41IDguNTAwMzkgMTMuOTMgOC41MDAzOSAxMkM4LjUwMDM5IDEwLjA3IDEwLjA3MDQgOC41IDEyLjAwMDQgOC41QzEzLjkzMDQgOC41IDE1LjUwMDQgMTAuMDcgMTUuNTAwNCAxMkMxNS41MDA0IDEzLjkzIDEzLjkzMDQgMTUuNSAxMi4wMDA0IDE1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EggAlt = createIcon('EggAlt', [
  [
    'path',
    {
      d: 'M19.0004 9C17.0004 7 15.9904 2 9.97039 2C4.95039 2 1.94039 6 2.00039 11.52C2.06039 17.04 6.96039 19 9.97039 19C11.9804 19 11.9804 22 15.9904 22C19.0004 22 22.0004 19 22.0004 15.02C22.0004 12 21.0104 11 19.0004 9ZM12.0004 15.5C10.0704 15.5 8.50039 13.93 8.50039 12C8.50039 10.07 10.0704 8.5 12.0004 8.5C13.9304 8.5 15.5004 10.07 15.5004 12C15.5004 13.93 13.9304 15.5 12.0004 15.5Z',
      key: 'qgwqxe',
    },
  ],
]);

export default EggAlt;
